import { useState, useEffect } from 'react';
import { UserOutlined, TransactionOutlined } from '@ant-design/icons';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import Tab2 from './Tab2';
import Operation from '../../../../Models/Operation';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import DataHistoCpt from '../../../../Types/DataHistoCpt';
import VerifDay from '../../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';
import { getField } from '../../../../utilitaires/globalFunction';
import { Person } from '@mui/icons-material';

//import '../../../Assets/Styles/StyleForm.css';
const Swal = require('sweetalert2');

const BackOffice = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [consulActive, setConsulActive] = useState(false)
    const [sbmit, setSbmit] = useState("");
    const [annulActive, setAnnulActive] = useState(true)
    const [DataOperation, setDataOperation] = useState<DataHistoCpt[]>([]);
    const [DataOperationV, setDataOperationV] = useState<DataHistoCpt[]>([]);
    const [StartRef, SetStartRef] = useState(false);
    const [UtiSai, SetUtiSai] = useState("");
    const Navigate = useNavigate();

    useEffect(() => {
        forceUpdate({});
        if (StartForm == true) {
            VerifDay(user.coduti, user.codage, authHeader, Navigate);
            GetAllOperation();
            SetStartForm(false);
        }
    }, [UtiSai]);


    function cunsultButton() {
        //setAnnulActive(false)
        setModifActve(false);
        SetStartRef(false);
        // SetActivetabs(true)
    }

    function initialiazeButton() {
        SeStartSearchG(false)
        setAjoutActif(false)
        setModifActve(true)
        setEnregActve(true)
        setConsulActive(false)
    }

    function handleAnulle() {
        SetStartRef(false)
        let REF = form.getFieldValue("Reference")
        form.resetFields()
        localStorage.clear()
        setDataOperation([])
        initialiazeButton()
        localStorage.setItem(Data.LocalVariable.reset, "1")
        SeStartSearchG(false)
        form.setFieldValue("Reference", REF)
    }

    const SetStart = async () => {

        let data = Crypter.encrypt('1');
        let data2 = Crypter.encrypt(user.codage);
        let data3 = Crypter.encrypt(user.codage);
        let data4 = Crypter.encrypt(user.codage);

        setLoading(true)
        SetStartRef(true);
        setAnnulActive(false);
        setDataOperation([])
        if (data.length != 0) {

            form.resetFields();

            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetReference,
                headers: {
                    'CypherStaOp': data4,
                    'CypherRefOp': data3,
                    'CypherCodAge': data2,
                    'CypherTypOp': data,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };

            await axios.request(config)
                .then((response) => {
                    setLoading(false);
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        if (res.StatutCode == 200) {

                            form.setFieldValue("Reference", res.Result);
                            setSbmit("add");
                            setAjoutActif(true);
                            setEnregActve(false)
                            setModifActve(true)
                            setConsulActive(true)
                        }
                        else {
                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                        }
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                });
            setLoading(false)
        }
    }

    const GetAllOperation = async () => {
        setLoading(true);
        setDataOperation([]);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetOperation,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherFilter': Crypter.encrypt('5'),
                'CypherCodeA': Crypter.encrypt(user.codage),
                'CypherCodeU': Crypter.encrypt(user.coduti),
                'CypherRepec': Crypter.encrypt('')
            }
        };

        await
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas = res.Result;

                            const Datat: DataHistoCpt[] = [];
                            if (datas.length === 0) {
                                //console.log("aucun élément ");
                            }
                            else {

                                let TotalDebit: number = 0;
                                let TotalCrebit: number = 0;
                                let NbrCrebit: number = 0;
                                let Nbrdebit: number = 0;

                                res.Result.map((data: any, indice: number) => {

                                    if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                    else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                    Datat.push({
                                        key: indice,
                                        NUMCPT: data.NODUCP,
                                        DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                        TIME: data.TIME.substring(11,),
                                        DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                        SENSEC: data.SENSEC,
                                        REPECE: data.REPECE,
                                        NUMRAP: data.NUMRAP,
                                        REFLIAI: data.REFLIAI,
                                        LIBELL: data.LIBELL,
                                        MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                        MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                        NBENEF: data.NBENEF,
                                        UTISAI: data.UTISAI
                                    });
                                })

                                setDataOperation(Datat);
                                form.setFieldValue("TotalDebitOP", formatNumber(TotalDebit));
                                form.setFieldValue('TotalCrebitOP', formatNumber(TotalCrebit));
                                form.setFieldValue("NbrCrebitOP", NbrCrebit);
                                form.setFieldValue("NbrdebitOP", Nbrdebit);
                                form.setFieldValue("SoldeOP", formatNumber(TotalCrebit - TotalDebit));
                                form.setFieldValue("NbrTotalOP", NbrCrebit + Nbrdebit);
                            }
                        }
                        setLoading(false);
                    }
                    //  setLoad(false);
                }).catch((error) => {

                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
        setLoading(false);
    }

    const GetAllOperationV = async () => {

        setLoading(true);
        setDataOperationV([]);

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetOperation,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherFilter': Crypter.encrypt('6'),
                'CypherCodeA': Crypter.encrypt(user.codage),
                'CypherCodeU': Crypter.encrypt(user.coduti),
                'CypherRepec': Crypter.encrypt('')
            }
        };

        await
            axios(config)
                .then((response) => {
                    //alert('ok')
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas = res.Result;

                            const Datat: DataHistoCpt[] = [];
                            if (datas.length === 0) {
                                //console.log("aucun élément ");
                            }
                            else {

                                let TotalDebit: number = 0;
                                let TotalCrebit: number = 0;
                                let NbrCrebit: number = 0;
                                let Nbrdebit: number = 0;

                                res.Result.map((data: any, indice: number) => {
                                    if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                    else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                    Datat.push({
                                        key: indice,
                                        NUMCPT: data.NODUCP,
                                        DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                        TIME: data.TIME.substring(11,),
                                        DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                        SENSEC: data.SENSEC,
                                        REPECE: data.REPECE,
                                        NUMRAP: data.NUMRAP,
                                        REFLIAI: data.REFLIAI,
                                        LIBELL: data.LIBELL,
                                        MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                        MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                        SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                        NBENEF: data.NBENEF,
                                        UTIVAL: data.UTIVAL,
                                        UTISAI: data.UTISAI
                                    });
                                })

                                setDataOperationV(Datat);
                                form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                                form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                                form.setFieldValue("NbrCrebit", NbrCrebit);
                                form.setFieldValue("Nbrdebit", Nbrdebit);
                                form.setFieldValue("Solde", formatNumber(TotalCrebit - TotalDebit));
                                form.setFieldValue("NbrTotal", NbrCrebit + Nbrdebit);
                            }
                        }
                        setLoading(false);
                    }
                    //  setLoad(false);
                }).catch((error) => {

                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
        setLoading(false);
    }

    const consult = async (Reference?: string) => {

         
   
        setLoading(true);
        setDataOperation([]);
        setAnnulActive(false);
        // form.resetFields()
        form.setFieldsValue({ "TotalDebitOP": '', 'TotalCrebitOP': '', 'NbrCrebitOP': '', 'NbrdebitOP': '', 'SoldeOP': '', 'NbrTotalOP': '', 'Devise': '', 'lib_Devise': '', 'AUTORI': '', 'CDDEVS': '', 'lib_CDDEVS': '' });

        let data = Crypter.encrypt(Reference ? Reference : JSON.stringify(form.getFieldValue("Reference")));
       
        if (data.length != 0) {
            var config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetOperation,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': authHeader(),
                    'CypherFilter': Crypter.encrypt('5'),
                    'CypherCodeA': Crypter.encrypt(user.codage),
                    'CypherCodeU': Crypter.encrypt(user.coduti),
                    'CypherRepec': Crypter.encrypt(form.getFieldValue("Reference"))
                }
            };

            await
                axios(config)
                    .then((response) => {

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                            if (res.StatutCode == 200) {
                                let datas = res.Result;

                                const Datat: DataHistoCpt[] = [];
                                if (datas.length > 0) {

                                    let TotalDebit: number = 0;
                                    let TotalCrebit: number = 0;
                                    let NbrCrebit: number = 0;
                                    let Nbrdebit: number = 0;

                                    res.Result.map((data: any, indice: number) => {

                                        if (data.SENSEC == "D") { Nbrdebit++; TotalDebit += data.MONTAN; }
                                        else { NbrCrebit++; TotalCrebit += data.MONTAN; }

                                        Datat.push({
                                            key: indice,
                                            NUMCPT: data.NODUCP,
                                            DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                                            TIME: data.TIME.substring(11,),
                                            DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                                            SENSEC: data.SENSEC,
                                            REPECE: data.REPECE,
                                            NUMRAP: data.NUMRAP,
                                            REFLIAI: data.REFLIAI,
                                            LIBELL: data.LIBELL,
                                            MONTANT: formatNumber(data.MONTAN ? data.MONTAN : ''),
                                            MONTANTDEBIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                            MONTANTCREDIT: formatNumber(data.MONTANT ? data.MONTANT : ''),
                                            SOLDT: formatNumber(TotalDebit + TotalCrebit),
                                            NBENEF: data.NBENEF,
                                            UTISAI: data.UTISAI,
                                            CODOPE: data.CDLBEC,
                                            NLIGNE: data.NLIGNE,
                                            NOMCPT: data.NOMCPT,
                                           // CODOPE: data.CDLBEC,
                                            RelObject: data
                                        });

                                        setDataOperation(Datat);
                                        form.setFieldValue("TotalDebitOP", formatNumber(TotalDebit));
                                        form.setFieldValue('TotalCrebitOP', formatNumber(TotalCrebit));
                                        form.setFieldValue("NbrCrebitOP", NbrCrebit);
                                        form.setFieldValue("NbrdebitOP", Nbrdebit);
                                        form.setFieldValue("SoldeOP", formatNumber(TotalCrebit - TotalDebit));
                                        form.setFieldValue("NbrTotalOP", NbrCrebit + Nbrdebit);

                                        cunsultButton();
                                    })
                                }
                            } else SweetAlert.fire({ title: "Error", text: res.Message, icon: "error" })
                            setLoading(false);
                        }
                        //  setLoad(false);
                    }).catch((error) => {
                        SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                    })
            setLoading(false);
        }
    }

    //Tab2
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Saisie des transactions locales
                </span>
            ),
            children: <Tab1 etatG={StartRef} form={form} DataOperation={DataOperation} GetAllOperation={consult} />,
        },
        {
            key: '2',
            label: (
                <span id='Tab'>
                    <TransactionOutlined />
                    Transactions Validées
                </span>
            ),
            children: <Tab2 form={form} DataOperation={DataOperationV} />,
        }
    ]

    const onFinish = (values: any) => {
     
 
           
        let Operation: Operation = values;
         
        Operation.aeducp = user.codage;
        Operation.codope = form.getFieldValue('CodeOpe');
        Operation.exoner = '';
        Operation.montant = form.getFieldValue('Montant');
        Operation.devis = '';
        Operation.taux = form.getFieldValue('Taux');
        Operation.sensec = '';
        Operation.datval = '';
        Operation.codanal = '';
        Operation.libanal = '';
        Operation.refauto = form.getFieldValue('Reference');
        Operation.refmanuel = form.getFieldValue('RefManuel');
        Operation.line = 0;
        Operation.codserv = '';
        Operation.datsys = '';
        Operation.nbenef = '';
        Operation.datope = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
        Operation.numcpt = '';
        Operation.annee = user.datjour.substring(0, 4);
        Operation.mois = user.datjour.substring(5, 7);
        Operation.litige = '';
        Operation.utisai = user.coduti;
        Operation.typope = '1';
        Operation.sensec = form.getFieldValue('Sence');
        Operation.ImportSai = [];
        // Client.DateDelcni = Client.DateDelcni? (new Date(Client.DateDelcni)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00" : ""
        // Client.DATNAI = (new Date(Client.DATNAI)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00"
        let Typeo = form.getFieldValue('Sence') == "D" ? "Debit" : "Credit";
         console.log(Operation)

        if (form.getFieldValue('Montant') > 0) {
            SweetAlert.fire({
                title: "Saisie D'opération",
                text: "Voulez-vous  effectuer une Opération de " + Typeo + " du Montant de : " + formatNumber(form.getFieldValue('Montant')) + ' XAF ' + " pour " + form.getFieldValue('lib_CodeOpe') + " ? ",
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then((res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //let group = profilsDistant.find(()=>)
                    //console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Client)));

                    let data = Crypter.encrypt(JSON.stringify(Operation));

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.SaisieOperation,
                        headers: {
                            'Accept': '*/*',
                            'cypherNumcptEm': Crypter.encrypt(form.getFieldValue('NUMCPT')),
                            'cypherLibEm': Crypter.encrypt(form.getFieldValue('lib_CodeOpe')),
                            'cypheNumcptRecpt': Crypter.encrypt(form.getFieldValue('')),
                            'cypherLibRecpt': Crypter.encrypt(form.getFieldValue('')),
                            'cypherDispon': Crypter.encrypt(ReformatNumber(form.getFieldValue('DISPON')).toString()),
                            'Authorization': authHeader(),
                            'cypherOption': Crypter.encrypt('2'),
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };

                    axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                if (res.StatutCode == 200) {
                                    let result = res.Result;
                                    // form.resetFields()
                                    localStorage.clear();
                                    setIsSubmit(false)
                                    SweetAlert.fire({ title: res.Message, text: result, icon: "success" })

                                    localStorage.clear();

                                    setSbmit("");

                                    form.setFieldsValue({ "NUMCPT": '', 'lib_NUMCPT': '', 'DISPON': '', 'BLOQUE': '', 'SOLVEI': '', 'Taux': 1, 'Montant': '', 'RefManuel': '', 'Devise': '', 'lib_Devise': '', 'AUTORI': '', 'CDDEVS': '', 'lib_CDDEVS': '' })

                                    consult();
                                }
                                else {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                        });
                }
            })
        } else {
            SweetAlert.fire({ title: "Sassie Invalide", text: "Le Montant Saissie est Null", icon: "error" })
        }

    };

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };



    function modifButton() {
        SetStartRef(true)
        setModifActve(true)
        setAjoutActif(true)
        setEnregActve(false)
        setConsulActive(true)
    }

    function modif() {
        modifButton()

    }
    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Saisie Back-Office local</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={consulActive} onClick={async e => {consult()}} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={modifActve} onClick={modif} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' type="ghost" htmlType="button" block>
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" onChange={(e) => { if (e == '2') { GetAllOperationV(); } }} defaultActiveKey="1" items={items} />
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>

    );
}
export default BackOffice;